function formatTimeFromDate(date){
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')

    return `${hours}:${minutes}:00`
}

export default formatTimeFromDate